import React, {useEffect, useState} from "react";
import "../App.css";
import {useNavigate} from "react-router-dom";
import avatarImage from "../Assets/profilePhoto.jpg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Footer from "../Components/Footer";
import logout from "../Api/logout";
import Swal from "sweetalert2";
import profile from "../Api/profile";
import changeProfileInfo from '../Api/changeProfileInfo';
import Logo from "../Assets/logo.png";
import starting from "../Api/starting";
import Copyright_Footer from "../Components/copyrightFooter";

export default function EditPersonal() {
    const navigate = useNavigate()
    const [userData, setUserData] = useState(null);
    const [imageSrc, setImageSrc] = useState(''); // State for holding image src
    const [previewImageSrc, setPreviewImageSrc] = useState(null); // State for holding image src

    const gender = [
        'Male',
        'Female'
    ];

    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const [selectedGender, setSelectedGender] = useState('');
    const [password, setPassword] = useState('');
    // const [withdrawPassword, setWithdrawPassword] = useState('');
    const [dashboardData, setDashboardData] = useState(null);
    const handleLogout = async () => {
        try {
            await logout();
            navigate("/");
            Toast.fire({
                icon: 'success',
                title: 'Successfully Logout'
            })
        } catch (error) {
            console.error('API Error:', error.message);
            Toast.fire({
                icon: 'Error',
                title: error.message
            })
        }
    }


    const handleImageUpload = (e) => {
        const file = e.target.files[0];

        const reader = new FileReader();

        reader.onloadend = () => {
            setPreviewImageSrc(reader.result);
        };

        if (file) {
            reader.readAsDataURL(file);
            setImageSrc(file);
        } else {
            setImageSrc(null);
        }
    };


    const handleOnSaveChange = async () => {
        let formData = {
            profileImage: imageSrc ?? '',
            gender: selectedGender ?? '',
            // transactionPassword: withdrawPassword ?? '',
            password: password ?? '',
        }


        try {
            const response = await changeProfileInfo(formData);
            console.log(response.data);
            Toast.fire({
                icon: 'success',
                title: 'Successfully Updated'
            })
        } catch (error) {
            console.error("API Error:", error.message);
            if (error.response.status === 401 || error.response.status === 500) {
                Toast.fire({
                    icon: 'error',
                    title: error.response.data.title
                })
                localStorage.clear();
                navigate("/");
            }
            Toast.fire({
                icon: 'error',
                title: error.response.data.message
            })
        }
    };


    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const response = await profile();
                setUserData(response.data);
                setSelectedGender(response.data.gender)
            } catch (error) {
                console.error("API Error:", error.message);
                if (error.response.status === 401 || error.response.status === 500) {
                    Toast.fire({
                        icon: 'error',
                        title: error.response.data.title
                    })
                    navigate("/");
                }
            }
        };

        const fetchStartingInfo = async () => {
            try {
                const response = await starting();
                setDashboardData(response.data);
            } catch (error) {
                console.error("API Error:", error.message);
                if (error.response?.status === 401) {
                    Toast.fire({
                        icon: 'error',
                        title: error.response.data.title
                    })
                    localStorage.clear();
                    navigate("/");
                }
                Toast.fire({
                    icon: 'error',
                    title: error.response.data.message
                })
            }
        };
        fetchStartingInfo()
        fetchUserInfo()
    }, []);

    const handelToLevelDetails = () => {
        navigate("/levels");
    };

    const handelWalletTrasactionHistory = () => {
        navigate("/walletTransactionHistory");
    }

    return (
        <>
            <div className="container mobile-page">
                <img src={Logo} alt="Logo" className='mt-5' width={150}/>

                <div className="container">
                    <div className="row">
                        <div className="col-12 profile-container">
                            <img className="rounded-circle mx-auto d-block border border-3 text-white"
                                 src={userData?.profilePicture ? userData?.profilePicture : avatarImage} alt="Profile"
                                 width={120}/>
                        </div>
                        <div className="light-black text-opacity-25 rounded-3 p-4 pt-5">
                            <div className="col-12 my-2 d-flex  justify-content-center align-items-center">
                                <span className='text-white fw-bold fs-5'>{userData?.memberName}
                                </span>
                                <img className='ms-2' src={userData?.vipLevelImageUrl} alt="Profile"
                                     width={40}/>
                            </div>
                            <div className="col-12 text-center">
                                <span className='text-white fs-6 me-2'>Referral Code</span>
                                <span className='text-white fw-bold fs-6'>{userData?.referralCode}</span>
                            </div>
                            <div className="col-12 mt-3">
                                <div className="d-flex justify-content-evenly text-center">
                                    <div className=" d-flex flex-column">
                                        <span
                                            className="fs-6 fw-bold text-pink">USDT {dashboardData?.dailyProfit}</span>
                                        <span className="text-white">Today Profit</span>
                                    </div>
                                    <div className="divider-right"></div>
                                    <div className="text-white d-flex flex-column">
                                        <span
                                            className="fs-6 fw-bold text-pink">USDT {dashboardData?.assetBalance}</span>
                                        <span className="text-white fs-6">Total Balance</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="personal-section mt-4 px-3 py-2 rounded-3">
                    <div className="personal-box px-2 py-3 d-flex justify-content-between align-items-center">
                        <span>Profile Image</span>
                        {/* Add file input for selecting or capturing photo */}
                        <input type="file" accept="image/*;capture=camera" onChange={handleImageUpload}
                               style={{display: 'none'}} id="fileUpload"/>
                        <img className="rounded-circle mx-auto d-block"
                             src={previewImageSrc ? previewImageSrc : userData?.profilePicture ? userData?.profilePicture : avatarImage}
                             alt="Profile"/>
                        <label className='d-flex' htmlFor="fileUpload">
                            <ArrowForwardIosIcon sx={{fontSize: 20, color: "var(--pink)"}}/>
                        </label>
                    </div>
                    <div className="personal-box px-2 py-3 d-flex justify-content-between">
                        <span>Username</span>
                        <span>{userData?.memberName}</span>
                    </div>
                    <div className="personal-box px-2 py-3 d-flex justify-content-between">
                        <span>Gender</span>
                        <select
                            className='bg-transparent text-white border-0'
                            value={selectedGender}
                            onChange={e => setSelectedGender(e.target.value)}>
                            {gender.map((value) => (
                                <option value={value} key={value}>
                                    {value}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="personal-box px-2 py-3 d-flex justify-content-between align-items-center" onClick={handelToLevelDetails}>
                        <span className='pe-none'>VIP Details</span>
                        <label className='d-flex' onClick={handelToLevelDetails}>
                            <ArrowForwardIosIcon sx={{fontSize: 20, color: "var(--pink)"}}/>
                        </label>
                    </div>
                    <div className="personal-box px-2 py-3 d-flex justify-content-between align-items-center" onClick={handelWalletTrasactionHistory}>
                        <span className='pe-none'>Wallet Transaction History</span>
                        <label className='d-flex' onClick={handelWalletTrasactionHistory}>
                            <ArrowForwardIosIcon sx={{fontSize: 20, color: "var(--pink)"}}/>
                        </label>
                    </div>
                </div>

                <div className="password-section mt-4 px-1 py-2 rounded-3">
                    <div className="rounded-4 py-1 px-4 my-2 d-flex flex-nowrap align-items-center">
                        <span className='text-white'>Login Password</span>
                        <input
                            className='ms-2 w-50 bg-transparent text-white'
                            id="securityPin"
                            name="password"
                            type="text"
                            placeholder="Type Here"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                </div>

                <div className="container">
                    <button className="save-btn mt-4 px-3 py-2 rounded-3" onClick={handleOnSaveChange}>Save Change
                    </button>

                    <button className="logout-btn mt-4 px-3 py-2 rounded-3" onClick={handleLogout}>Log out</button>
                </div>

                {/*<div className="personal-box px-2 py-3">*/}
                {/*    <input*/}
                {/*        id="withdrawPassword"*/}
                {/*        name="withdraw_password"*/}
                {/*        type="text"*/}
                {/*        placeholder="Change Withdraw Password"*/}
                {/*        value={withdrawPassword}*/}
                {/*        onChange={(e) => setWithdrawPassword(e.target.value)}*/}
                {/*    />*/}
                {/*</div>*/}
                {/*<div className="personal-box px-2 py-3">*/}
                {/*    <input*/}
                {/*        className='deepBlack text-white'*/}
                {/*        id="securityPin"*/}
                {/*        name="password"*/}
                {/*        type="text"*/}
                {/*        placeholder="Log Password"*/}
                {/*        value={password}*/}
                {/*        onChange={(e) => setPassword(e.target.value)}*/}
                {/*    />*/}
                {/*</div>*/}

                <Copyright_Footer/>
            </div>
            <Footer/>
        </>
    );
}
